import React, { useEffect, useState } from 'react'
import {
  Btn,
  BtnIcon,
  CanhotoPrestacaoContasStatus,
  CustomDropdown,
  CustomModal,
  InputNumeroDecimal,
  InputText,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { errorHandler } from '../../../../services/util/error.service'
import MovimentacaoLastMileHttp from '../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { FaRegTrashAlt } from 'react-icons/fa'

export default function ModalCanhoto({ visible, onResponse, selectedPrestacaoContas, ativos }) {
  const [isLoading, setIsLoading] = useState(false)
  const [numeroCanhoto, setNumeroCanhoto] = useState('')
  const [selectedAtivo, setSelectedAtivo] = useState('')
  const [qte, setQte] = useState('')
  const [canhotos, setCanhotos] = useState([])

  useEffect(() => {
    if (selectedPrestacaoContas && selectedPrestacaoContas.canhotos.length > 0) {
      setCanhotos([...selectedPrestacaoContas.canhotos])
    }
  }, [visible])

  //Events
  const onBtnSalvarClick = async () => {
    try {
      checkConsistencia()
      const newCanhoto = {
        prestacao_contas_id: selectedPrestacaoContas.id,
        num_nf_canhoto: numeroCanhoto,
        patrimonio_ativo_id: selectedAtivo.ativo_id,
        qte,
      }
      setIsLoading(true)
      const savedCanhoto = await MovimentacaoLastMileHttp.addCanhoto(newCanhoto)
      clearForm()
      onResponse('success', {
        prestacao_contas_id: selectedPrestacaoContas.id,
        canhotos: [...selectedPrestacaoContas.canhotos, savedCanhoto],
      })
      setCanhotos(prevState => {
        prevState.push(savedCanhoto)
        return [...prevState]
      })
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  const onBtnDeleteClicked = async canhoto => {
    try {
      setIsLoading(true)
      await MovimentacaoLastMileHttp.deleteCanhoto(canhoto.id)
      clearForm()
      onResponse('success', {
        prestacao_contas_id: selectedPrestacaoContas.id,
        canhotos: canhotos.filter(c => c.id !== canhoto.id),
      })
      setCanhotos(prevState => {
        prevState = prevState.filter(c => c.id !== canhoto.id)
        return [...prevState]
      })
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  // Helpers
  const checkConsistencia = () => {
    if (numeroCanhoto === '') throw new Error('Campo Número do Canhoto incorreto')
    if (selectedAtivo === '') throw new Error('Campo Ativo incorreto')
    if (qte === '' || Number.isNaN(qte) || Number(qte) <= 0)
      throw new Error('Campo Quant. incorreto')
  }

  const clearForm = () => {
    setNumeroCanhoto('')
    setSelectedAtivo('')
    setQte('')
  }

  // Render
  return (
    <CustomModal
      header={'Lançamento dos Canhotos'}
      onClose={() => onResponse('close')}
      isVisible={visible}
      width={700}
    >
      <div className="p-grid">
        <div className="p-col-3">
          <InputText
            label={'Número do Canhoto'}
            value={numeroCanhoto}
            marginTop={0}
            onChange={value => setNumeroCanhoto(value)}
          />
        </div>
        <div className="p-col-5">
          <CustomDropdown
            marginTop={0}
            onChange={value => setSelectedAtivo(value)}
            value={selectedAtivo}
            label={'Ativo'}
            options={ativos.map(a => ({ ativo_id: a.ativo_id, ativo_name: a.ativo_name }))}
            optionLabel={'ativo_name'}
          />
        </div>
        <div className="p-col-2">
          <InputNumeroDecimal
            value={qte}
            onChange={value => setQte(Number(value))}
            marginTop={0}
            label={'Quant.'}
          />
        </div>
        <div className="p-col-2" style={{ paddingTop: 28 }}>
          <Btn isLoading={isLoading} onClick={onBtnSalvarClick}>
            Salvar
          </Btn>
        </div>
        <div className="p-col-12">
          <DataTable
            loading={isLoading}
            value={canhotos}
            emptyMessage={'Não existe canhoto cadastrado '}
            paginator={true}
            rows={5}
          >
            <Column field={'num_nf_canhoto'} header={'Canhoto'} style={tableCellCentered(120)} />
            <Column field={'patrimonio_ativo_name'} header={'Ativo'} />
            <Column field={'qte'} header={'Quantidade'} style={tableCellCentered(100)} />
            <Column
              field={'status'}
              header={'Status'}
              body={canhoto => <CanhotoPrestacaoContasStatus status={canhoto.status} />}
              style={tableCellCentered(100)}
            />
            <Column
              header=""
              body={canhoto => (
                <BtnIcon onClick={() => onBtnDeleteClicked(canhoto)}>
                  <FaRegTrashAlt color="red" size={18} />
                </BtnIcon>
              )}
              style={{ textAlign: 'center', width: 80 }}
            />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}
